import Operate from "./Operate";
import Comment from "./Comment";
import { TrendItem } from "@/config/types/trend";
import VideoBox from "./VideoBox";
// import { JobItem } from "@/config/types/job";

export default function Video({
  data,
}: // jobList,
// total,
// openAppTrendDetail,
{
  data: TrendItem;
  // jobList: JobItem[];
  // total: number;
  // openAppTrendDetail: () => void;
}) {
  return (
    <div className="video-wrap">
      <VideoBox data={data} />
      <Operate theme="dark" data={data} />
      {/* <Job theme="dark" jobList={jobList} total={total} openAppTrendDetail={openAppTrendDetail} /> */}
      <Comment theme="dark" />
    </div>
  );
}
